import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { APP_VERSION } from '../../config/version';
import { login } from '../../services/authService';
// Validador
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
// Componentes UI
import { Toast } from 'primereact/toast';
// Estilos
import KyriosCo_color from '../../assets/logos/KyriosCo._Color.avif';
import './login.css';

const schema = yup.object().shape({
  usuario: yup.string().required('El usuario es obligatorio'),
  password: yup.string().required('La contraseña es obligatoria'),
});

export default function LoginForm() {
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
    mode: 'onTouched',
    defaultValues: { usuario: '', password: '' },
  });

  const navigate = useNavigate();
  const toast = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = async (data) => {
    setIsSubmitting(true);

    try {
      await login(data);
      navigate('/app');

    } catch (error) {
      const detail = error?.response?.data?.msg || error?.message || 'Error al iniciar sesión';

      toast.current?.show({
        severity: 'error', summary: 'No pudimos iniciar sesión',
        detail, life: 3500
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-background">
      <Toast ref={toast} position="center"/>

      <div className="login-container">
        <form onSubmit={handleSubmit(onSubmit)} noValidate className="needs-validation login-form">
          
          {/* Header */}
          <div className="login-logo-container">
            <img src={KyriosCo_color} alt="Kyrios Co." className="login-logo" />
            <div className="version-chip">v{APP_VERSION}</div>
          </div>

          {/* Content */}
          <div className="login-content">
            <div className="login-campos">
              <div className="mb-3">
                <label className="form-label">Usuario</label>
                <input
                  type="text"
                  placeholder='Ingrese su usuario'
                  className={`form-control ${errors.usuario ? 'is-invalid' : ''}`}
                  autoComplete="username"
                  autoFocus
                  {...register('usuario')}
                />
                {errors.usuario && (
                  <div className="invalid-feedback">{errors.usuario.message}</div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">Contraseña</label>
                <div className="password-wrapper">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Ingrese su contraseña"
                    className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                    autoComplete="current-password"
                    {...register('password')}
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                    onClick={() => setShowPassword((v) => !v)}
                  >
                    <i className={showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'} />
                  </button>
                  {errors.password && (
                    <div className="invalid-feedback d-block">{errors.password.message}</div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="btn-group-login">
            <button type="submit" className="btn-iniciar-sesion" disabled={isSubmitting}>
              {isSubmitting ? 'Comprobando...' : 'Entrar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
